// @flow

import { connect } from "react-redux";

import type { State } from "src/types";
import { getTempAttachment } from "src/reducers";
import { clearTempAttachment } from "src/actions/email";

import Item from "./Item";

const mapStateToProps = ({ app }: State, { id }) => {
  const file = getTempAttachment(app, id);

  return {
    id,
    uploading: file.uploading,
    progress: file.progress,
    name: file.meta?.originalName,
    size: file.meta?.size,
  };
};

const mapDispatchToProps = {
  removeItem: clearTempAttachment,
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
